var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"TransactionHistoryGroup"},[_c('h3',{staticClass:"TransactionHistoryGroup__title"},[_vm._v(_vm._s(_vm.formatDate(_vm.title)))]),_c('ol',{staticClass:"TransactionHistoryGroup__list"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }